import styled from "styled-components";

export const TableStyle = styled.div`
  & {
      .table {
        .body {
            .tr {
                :last-child {
                  .td {
                      border-top: 5px double black;
                      font-weight: bold;     
                  }        
                }
                .td:not(:last-child) {
                  text-align: center;
                }
            }
        }

        .header {
           .tr {
                .th {
                  text-align: center;
                }
            }
        }
      }
  }
`;
